import { render, staticRenderFns } from "./ShippingDestinyTransportationList.vue?vue&type=template&id=987fa692"
import script from "./ShippingDestinyTransportationList.vue?vue&type=script&lang=js"
export * from "./ShippingDestinyTransportationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports